import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LogIn from 'wanderu-component-account-login';
import {
    logInAction,
} from 'wanderu-ducks-account';
// import {
//     localize,
// } from 'wanderu-i18n';

// import baseAppConfig from '../../config/baseApp.locales';

function BareLogInContainer(props) {
    const {
        cognitoLoginFailed,
        cognitoLogIn,
        facebookLogIn,
        googleButtonLogIn,
        resetLogInAction,
        userHasThirdPartyAccount,
        working,
        ...otherProps
    } = props;

    return (
        <LogIn
            cognitoLoginFailed={cognitoLoginFailed}
            hasError={cognitoLoginFailed || userHasThirdPartyAccount}
            loginFetching={working}
            onFacebookClick={facebookLogIn}
            onFormFocus={resetLogInAction}
            onGoogleClick={googleButtonLogIn}
            onLogIn={cognitoLogIn}
            userHasThirdPartyAccount={userHasThirdPartyAccount}
            {...otherProps}
        />
    );
}

BareLogInContainer.propTypes = {
    className: PropTypes.string,
    defaultValues: PropTypes.object,
    cognitoLogIn: PropTypes.func.isRequired,
    working: PropTypes.bool,
    cognitoLoginFailed: PropTypes.bool,
    userHasThirdPartyAccount: PropTypes.bool.isRequired,
};

BareLogInContainer.defaultProps = {
    working: false,
    cognitoLoginFailed: false,
    userHasThirdPartyAccount: false,
};

const mapStateToProps = (appState) => {
    const working = logInAction.selectWorking(appState);
    const loginError = logInAction.selectError(appState) || {};

    const cognitoLoginFailed = loginError.name === 'CognitoUnableToAuthenticateUserError';
    const userHasThirdPartyAccount = loginError.name === 'LoginFailedUseThirdPartyError';

    return {
        working,
        cognitoLoginFailed,
        userHasThirdPartyAccount,
    };
};

const mapDispatchToProps = {
    cognitoLogIn: logInAction.cognitoLogIn,
    facebookLogIn: logInAction.facebookLogIn,
    googleButtonLogIn: logInAction.googleButtonLogIn,
    resetLogInAction: logInAction.reset,
};

export {
    BareLogInContainer,
    mapStateToProps,
};

// const localizedBareLogInContainer = localize(BareLogInContainer, [`t`], baseAppConfig.namespace);
export default connect(mapStateToProps, mapDispatchToProps)(BareLogInContainer);
